export const isDefined = value => value !== null && value !== undefined
export const isDefinedAndNotEmpty = value => value !== null && value !== undefined && value !== ''



// WEBPACK FOOTER //
// ./src/utils/isDefined.js